














































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Children } from './types';
import ButtonCanRequest from '@/presets/button/can-request';
import {
  Breadcrumbs as BreadcrumbsLayout,
  Extra as ExtraLayout,
} from '@/components/layout';
import {
  OrderHeader,
  OrderInfo,
  OrderWrapper,
  OrderDatepicker,
  OrderChildren,
  OrderSpinner,
  OrderMessage,
  OrderAddChildren,
} from '@/components/orders';
import { ITimePeriodsByDatesItem } from '@/pages/activities/card/types';
import {
  Select as FormSelect,
  Input as FormInput,
  Checkbox as FormCheckBox,
} from '@/components/form';
import File from '@/pages/profile/blocks/form/components/file';
import Textarea from '@/pages/profile/blocks/form/components/textarea';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import {
  ACTION_FETCH,
  SEND_ACTIVITY_ORDER,
  STORE_MODULE_NAME,
} from '@/pages/activities/card/const';
import { mapActions } from 'vuex';
import { formDataInputs } from '@/tools/formdatainputs';
const actions = mapActions(STORE_MODULE_NAME, [
  ACTION_FETCH,
  SEND_ACTIVITY_ORDER,
]);
const send = actions[SEND_ACTIVITY_ORDER];

@Component({
  components: {
    AppButtonNew,
    OrderSpinner,
    BreadcrumbsLayout,
    ButtonCanRequest,
    OrderHeader,
    OrderInfo,
    OrderWrapper,
    OrderDatepicker,
    OrderChildren,
    OrderMessage,
    OrderAddChildren,
    FormSelect,
    FormInput,
    FormCheckBox,
    File,
    Textarea,
  },
})
export default class PagesOrderActivites extends Vue {
  @Prop({ type: Function })
  nextStep: Function;

  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: String, default: '' })
  address: string;

  @Prop({ type: String, default: '' })
  membersOfActivity: string;

  @Prop({ type: Boolean, default: false })
  isChildrenInOrder: boolean;

  @Prop({ type: Boolean, default: false })
  isChildrenErrorMessage: boolean;

  @Prop({ type: Array, default: () => [] })
  children: Children;

  @Prop({ type: Array, default: () => [] })
  unselectedChildren: Children;

  @Prop({ type: Boolean, default: false })
  isAddChildError: boolean;

  @Prop({ type: Boolean, default: false })
  hasSending: boolean;

  @Prop({ type: Boolean, default: false })
  hasSent: boolean;

  @Prop({ type: Object, default: null })
  activeDates: any;

  @Prop({ type: Object, default: null })
  disabledDates: any;

  @Prop({ type: Date, required: true })
  dateOrder: Date;

  @Prop({ required: false })
  timeId: number | null;

  @Prop({ type: String, default: null })
  srvErrorMsg: string | null;

  @Prop({ type: Object, default: null })
  file: string;

  @Prop({ type: String, default: '' })
  answer: string;

  date: Date = this.dateOrder;
  showOrderMessage = false;
  selectedTimeItem: ITimePeriodsByDatesItem | null = null;
  eduLvl: any = '';
  organizationId: any = '';
  organizationName = '';
  registered = false;

  @Watch('date')
  isDateChange(value: Date) {
    this.$emit('dateChanged', value);
  }

  @Watch('hasSent')
  isHasSent(value: boolean) {
    if (value && !this.srvErrorMsg) this.showOrderMessage = value;
  }

  get getOptions() {
    return [
      ...this.$store.state.activityOrderEduLevelDict.map((el: any) => {
        return { value: el.id, text: el.name };
      }),
    ];
  }

  get getOrganizations() {
    return [
      ...this.$store.state.organizationsDict.map((el: any) => {
        return { value: el.id, text: el.name };
      }),
    ];
  }

  get isButtonDisabled(): boolean {
    if (!this.eduLvl) {
      return true;
    }
    if (this.registered && !this.organizationId) {
      return true;
    } else if (!this.registered && !this.organizationName) {
      return true;
    }
    return false;
  }

  get getImpossibleText() {
    if (this.isChildrenErrorMessage) {
      return undefined;
    }
    return 'Записаться';
  }

  removeChildFromOrder(value: number) {
    this.$emit('removeChildFromOrder', value);
  }

  addCheckedChildren(value: Array<string>) {
    this.$emit('addCheckedChildren', value);
  }
  get timePeriodsByDates() {
    return this.$store.state.activityCard.timePeriodsByDates;
  }

  async onSubmit() {
    const activityId = this.$store.state.activityCard.activity.id;
    const userId = this.$store.getters['user/userId'];
    const data = {
      activity_id: activityId,
      activity_date: this.selectedTimeItem?.startDate,
      is_partner_exists: this.registered ? 1 : 0,
      partner_id: this.registered ? this.organizationId : undefined,
      answer: this.answer || undefined,
      file: this.file || undefined,
      organization_name: !this.registered
        ? this.organizationName || undefined
        : undefined,
      'students[0][id]': userId,
      'students[0][edu_level]': this.eduLvl ? this.eduLvl : undefined,
    };
    const formData = formDataInputs(data);
    try {
      const msg = await send.call(this, formData);
      this.$emit('sendResult', msg);
    } catch (e) {
      this.$emit('sendResult', {
        type: 'error',
      });
    }
    this.nextStep();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/activities/card/order/ActivitesOrder.vue